<template>
  <el-container class="service-order-config-wrap">
    <el-header>
      <publicBreadCrumb :breadList="breadList" />
    </el-header>
    <el-main>
      <el-container style="height:100%">
        <el-aside>
          <h5 class="tag">服务类型</h5>
          <div class="type-row" v-for="(item, index) in serviceTypeList" :key="index" @click="handleDetailContent(item)">
            <span class="type-name" :class="[serviceFormData.id === item.id ? 'active-bg' : '']">{{ item.name }}</span>
            <div class="type-option">
              <el-button type="text" size="medium" @click.stop="handleDetailContent(item)">编辑</el-button>
              <span class="line-sepa"></span>
              <el-button type="text" size="medium" @click.stop="handleDelType(item)">删除</el-button>
            </div>
          </div>
          <!-- <el-button size="small" class="add-item" type="primary" style="margin-bottom:20px;margin-top:22px" @click="addCheckType"> + 添加一条类型</el-button> -->
        </el-aside>
        <div class="content-form">
          <h5 class="tag">服务类型配置</h5>
          <el-form ref="serviceForm" label-width="125px" :model="serviceFormData" :rules="serviceFormRules">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="服务类型名称：" prop="name">
                  <el-input placeholder="请输入服务类型名称" size="medium" v-model="serviceFormData.name" clearable
                    style="width:100%">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24" style="position:relative">
                <el-form-item label="可提供服务：" required>
                  <el-button style="width:70%" size="small" class="add-item addservice" type="primary"
                    @click="handleAddService"> + 添加服务</el-button>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="服务列表：" prop="nursingList">
                  <el-table v-if="serviceFormData.nursingList.length" :data="serviceFormData.nursingList"
                    :cell-style="{ textAlign: 'center' }"
                    :header-cell-style="{ textAlign: 'center', color: '#333333', fontSize: '14px', fontWeight: 'bold', backgroundColor: '#FAFAFA' }"
                    stripe style="width: 588px">
                    <el-table-column label="序号" width="80" type="index">
                    </el-table-column>
                    <el-table-column prop="name" show-overflow-tooltip label="服务名称">
                    </el-table-column>
                    <el-table-column align="center" label="操作" width="150">
                      <template slot-scope="scope">
                        <el-button type="text" size="medium" @click="handleLook(scope.row)">查看</el-button>
                        <el-button type="text" size="medium" @click="handleDel(scope.$index)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <span v-else class="no-data">暂无数据</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <!-- <el-button size="small" @click="handleCancel">取消</el-button> -->
          <el-button size="small" @click="handleCancel">重置</el-button>
          <el-button type="primary" size="small" class="btn-bg" @click="saveTypeForm">保存</el-button>
        </div>
        <div :class="[isShowAddService ? 'add-service-form-content' : 'un-show-right']">
          <!-- 添加服务 -->
          <div v-show="edit && isShowAddService">
            <h5 class="tag">添加服务</h5>
            <div>
              <el-form ref="serviceTypeForm" label-width="180px" :model="serviceTypeObj" :rules="serviceTypeFormRules">
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="服务名称：" prop="name">
                      <el-input v-model="serviceTypeObj.name" size="medium" clearable placeholder="请输入服务名称" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务价格：" prop="price">
                      <el-input v-model="serviceTypeObj.price" size="medium" clearable placeholder="请输入服务价格">
                        <template slot="append">元 / 次</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="建议时长：" prop="serviceTime">
                      <el-input v-model="serviceTypeObj.serviceTime" size="medium" clearable placeholder="请输入建议时长">
                        <el-select v-model="serviceTypeObj.serviceTimeUnit" slot="append" placeholder="请选择">
                          <el-option label="时 / 次" value="1"></el-option>
                          <el-option label="分 / 次" value="2"></el-option>
                        </el-select>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务卡片显示简介：" prop="introduction">
                      <el-input type="textarea" placeholder="请输入内容" v-model="serviceTypeObj.introduction" maxlength="80"
                        show-word-limit>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务概述：" prop="overview">
                      <el-input type="textarea" placeholder="请输入内容" v-model="serviceTypeObj.overview" maxlength="80"
                        show-word-limit>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务介绍，适用范围：" prop="applyScope">
                      <el-input type="textarea" placeholder="请输入内容" v-model="serviceTypeObj.applyScope" show-word-limit>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="intro-detail">
                    <el-form-item label="服务介绍详情：" required prop="introductionList">
                      <el-input v-for="(item, index) in serviceTypeObj.introductionList" :key="index" type="textarea"
                        placeholder="" v-model="item.info" show-word-limit style="margin-bottom:10px;width:100%">
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="">
                      <el-button size="small" class="add-item" style="width:100%" type="primary"
                        @click="handleAddIntroDetail"> + 新增介绍详情</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务介绍，不适用范围：" prop="notApplyScope">
                      <el-input type="textarea" placeholder="请输入内容" v-model="serviceTypeObj.notApplyScope"
                        show-word-limit>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="预约须知：" required>
                      <!-- <div id="tool-editor"></div> -->
                      <wangeditorNew :formData="serviceTypeObj" :index="0" :isCheck="isCheck" v-if="isCheck"
                        @content="contentChange"></wangeditorNew>
                      <span v-if="isShowError && !(serviceTypeObj.risk.trim())" class="item__error">
                        此项为必填项
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务评估问卷：" required>
                      <div v-if="addQuestionObj.title" class="select-question">
                        <el-tag closable @close="handleClose">{{ addQuestionObj.title }}</el-tag>
                      </div>
                      <el-button v-else size="small" class="add-item addservice" type="primary" @click="handleShowDialog">
                        + 添加问卷</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="上传知情同意书（PDF):" prop="informedConsentName">
                      <el-upload class="avatar-uploader" action="/api/dsicm-contact-platform/feign/file/upload"
                        :before-upload="beforeAvatarUpload" :headers="headers" :data="{ path: 'dsicm-service' }"
                        :show-file-list="false" :on-success="handleChange">
                        <img v-if="serviceTypeObj.informedConsentName" src="../../../../assets/images/pdf.png"
                          style="margin-right:18px">
                        <span v-if="serviceTypeObj.informedConsentName" style="vertical-align:top">{{
                          serviceTypeObj.informedConsentName }}</span>
                        <el-button v-else size="small" class="add-item addservice" type="primary"> + 上传附件</el-button>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div style="text-align:center">
              <!-- <el-button size="small" @click="handleCancelService">取消</el-button> -->
              <el-button size="small" @click="handleReset">重置</el-button>
              <el-button type="primary" size="small" class="btn-bg" @click="saveServiceForm">保存</el-button>
            </div>
          </div>
          <!-- 查看服务 -->
          <div v-show="!edit && isShowAddService">
            <h5 class="tag">查看{{ serviceTypeObj.name }}</h5>
            <div>
              <el-form label-width="180px" :model="serviceTypeObj">
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="服务名称：" prop="name" required>
                      <span>{{ serviceTypeObj.name }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务价格：" prop="price" required>
                      <span>{{ serviceTypeObj.price }}元 / 次</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="建议时长：" prop="serviceTime" required>
                      <span>{{ serviceTypeObj.serviceTime }}{{ Number(serviceTypeObj.serviceTimeUnit) ===
                        1 ? '时/次' : '分/次' }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务卡片显示简介：" prop="introduction" required>
                      <span>{{ serviceTypeObj.introduction }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务概述：" prop="overview" required>
                      <span>{{ serviceTypeObj.overview }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务介绍，适用范围：" prop="applyScope" required>
                      <span>{{ serviceTypeObj.applyScope }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="intro-detail">
                    <el-form-item label="服务介绍详情：" required prop="introductionList">
                      <p v-for="(item, index) in serviceTypeObj.introductionList" :key="index">
                        {{ serviceTypeObj.applyScope }}</p>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务介绍，不适用范围：" prop="notApplyScope" required>
                      <span>{{ serviceTypeObj.notApplyScope }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="预约须知：" required>
                      <span v-html="serviceTypeObj.risk"></span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="服务评估问卷：" required>
                      <el-tag>{{ addQuestionObj.title }}</el-tag>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <el-form-item label="上传知情同意书（PDF):" required>
                      <img v-if="serviceTypeObj.informedConsentName" src="../../../../assets/images/pdf.png"
                        style="margin-right:18px">
                      <span v-if="serviceTypeObj.informedConsentName" style="vertical-align:top">{{
                        serviceTypeObj.informedConsentName }}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div style="padding-left:180px">
              <el-button size="small" type="primary" class="btn-bg" style="width:110px"
                @click="handleToEdit">去编辑</el-button>
            </div>
          </div>
        </div>
      </el-container>
    </el-main>
    <!-- 添加问卷 -->
    <addQuestionDialog v-if="showAddQuestion" :showAddQuestion.sync="showAddQuestion" :selectRow="selectRow"
      @receiveQuestion="receiveQuestion" />
  </el-container>
</template>
<script>
import { questionnaireDetails } from "@/api/questionnaireManage"
import wangeditorNew from '@/components/wangeditorNew/index.vue'
import addQuestionDialog from '@/views/ToolMaintenance/component/addQuestionDialog'
import { serviceTypeList, deleteServiceType, addServiceType } from "@/api/serviceOrder"
import { DEEP_CLONE } from '@/utils/constants'

export default {
  components: {
    addQuestionDialog,
    wangeditorNew
  },
  data() {
    let checkService = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请添加服务'))
      } else {
        callback()
      }
    }
    let checkInfoIntro = (rule, value, callback) => {
      if (!value.length) {
        callback(new Error('请填写服务详情'))
      } else {
        let introductionDetailList = value.filter(v => v.info)
        introductionDetailList = introductionDetailList.map(v => v.info)
        let detailVal = introductionDetailList.some(sub => sub)
        if (!detailVal) {
          callback(new Error('请填写服务详情'))
        } else {
          callback()
        }
      }
    }
    return {
      breadList: [{ name: '医护上门管理' }, { name: '服务订单配置' }],
      isShowError: false,
      typeFlag: true,
      headers: {
        Authorization: localStorage.getItem('Authorization'),
      },
      edit: false,
      isShowAddService: false,
      serviceTypeObj: {
        serviceTimeUnit: '2',
        introductionList: [{
          info: ''
        }],
        name: '',
        price: '',
        serviceTime: '',
        introduction: '',
        overview: '',
        applyScope: '',
        // introductionList: [],
        notApplyScope: '',
        risk: '',
        content: '',
        informedConsentName: '',
        informedConsentUrl: ''
      },
      paperId: '',

      serviceTypeFormRules: {
        name: [
          { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
        ],
        price: [
          { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
          { pattern: /^0\.([1-9]|\d[1-9])$|^[1-9]\d{0,4}\.\d{0,2}$|^[1-9]\d{0,4}$/, message: '正数，小数点前5位，保留两位小数', trigger: ['change', 'blur'] }
        ],
        serviceTime: [
          { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
          { pattern: /^\+?[1-9]\d*$/, message: '大于0正整数', trigger: ['change', 'blur'] }
        ],
        introduction: [
          { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
        ],
        overview: [
          { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
        ],
        applyScope: [
          { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
        ],
        // name: [
        //   { required: true, message: '请输入服务名称', trigger: ['change', 'blur'] },
        // ],
        notApplyScope: [
          { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
        ],
        // risk: [
        //   // { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
        //   { validator: checkRisk, trigger: ['change', 'blur'] }
        // ],
        informedConsentName: [
          { required: true, message: '此项为必填项', trigger: ['change', 'blur'] },
        ],
        introductionList: [
          { validator: checkInfoIntro, trigger: ['change', 'blur'] }
        ]
      },

      addQuestionObj: {
        id: '',
        title: ''
      },
      selectRow: {},
      serviceTypeList: [],
      serviceFormData: {
        id: '',
        nursingList: [],
        name: ''
      },
      serviceFormRules: {
        name: [
          { required: true, message: '请输入服务名称', trigger: ['change', 'blur'] }
        ],
        nursingList: [
          { validator: checkService, trigger: ['change', 'blur'] }
        ]
      },
      showAddQuestion: false,
      editor: '',
      uploadImageUrl: '/api/dsicm-contact-platform/feign/file/rich-text-editor/upload',
      uploadVideoUrl: '/api/dsicm-contact-platform/feign/file/rich-text-editor/upload/video',
      cloneMainRowData: {},
      isCheck: false,
    }
  },
  async created() {
    this.getServiceTypeList()
  },
  watch: {
    'serviceTypeObj.risk': {
      handler(newVal, oldVal) {
        this.isShowError = true
      },
      deep: true
    }
  },
  mounted() {
  },
  methods: {
    beforeAvatarUpload(file) {
      let suffix = file.name.substring(file.name.lastIndexOf('.') + 1) === 'pdf'
      if (!suffix) {
        this.$message.error('仅支持上传PDF格式!')
      } else {
        this.$set(this.serviceTypeObj, 'informedConsentName', file.name)
        this.$refs.serviceTypeForm.clearValidate(['informedConsentName'])
      }
      return suffix
    },
    handleChange(file) {
      this.serviceTypeObj.informedConsentUrl = file.data
      this.$message.success('上传成功')
    },
    handleClose() {
      // this.addQuestionObj.title = ''
      this.$set(this.addQuestionObj, 'title', '')
      this.$set(this.addQuestionObj, 'id', '')
    },

    uploadVideoError(xhr, editor, resData) {
    },
    handleToEdit() {
      this.edit = true
      this.isCheck = true
    },
    // 添加服务
    handleAddService() {
      this.edit = true
      this.isCheck = true
      this.initAddServiceForm()
      this.isShowAddService = true
    },
    // 初始化添加服务表单
    initAddServiceForm() {
      this.isCheck = false;
      this.$refs.serviceTypeForm.resetFields()
      this.$set(this.addQuestionObj, 'title', '')
      this.$set(this.addQuestionObj, 'id', '')
      this.serviceTypeObj.introductionList = [{
        info: ''
      }]
      this.serviceTypeObj.risk = ''
      this.serviceTypeObj.content = ''
      this.serviceTypeObj.content = ''
      // this.editor.txt.html('')
      this.serviceTypeObj.id = ''
      this.serviceTypeObj.informedConsentName = ''
      this.serviceTypeObj.informedConsentUrl = ''
      this.isShowError = false;
      setTimeout(() => {
        this.isCheck = true
      }, 50)
    },
    // 初始化服务类型配置表单
    initServiceConfigForm() {
      this.$refs.serviceForm.resetFields()
      this.serviceFormData.id = ''
      this.serviceFormData.nursingList = []
    },
    // handleCancelService() {
    //   this.serviceFormData = this.cloneMainRowData
    //   this.isShowAddService = false
    // },
    // 添加介绍详情
    handleAddIntroDetail() {
      this.serviceTypeObj.introductionList.push({
        info: ''
      })
    },
    saveServiceForm() {
      let introductionDetailList = this.serviceTypeObj.introductionList.filter(v => v.info)
      introductionDetailList = introductionDetailList.map(v => v.info)
      // return
      this.serviceTypeObj.introductionDetail = JSON.stringify(introductionDetailList)

      // let detailVal = introductionDetailList.some(sub=>sub)
      this.isShowError = true
      let valRes
      this.$refs.serviceTypeForm.validate(val => {
        valRes = val
      })
      if (!this.serviceTypeObj.informedConsentUrl) {
        this.$message.warning('知情同意书正在上传中，请稍等..')
        return
      }
      if (!this.serviceTypeObj.risk.trim() || !valRes) {
        return
      }
      // if (!valRes) {
      //   return
      // }
      // if (!detailVal) {
      //   this.$message.warning('请填写服务详情')
      //   return
      // }
      if (!this.addQuestionObj.title) {
        this.$message.warning('请添加服务评估问卷')
        return
      }
      this.serviceTypeObj.qsExamPaperId = this.addQuestionObj.id

      let addData = DEEP_CLONE(this.serviceTypeObj)
      delete addData.introductionList

      // addData.id = this.serviceFormData.nursingList.length

      if (!this.serviceTypeObj.id && !this.serviceTypeObj.idset) {
        if (!this.serviceFormData.nursingList) {
          this.serviceFormData.nursingList = []
        }
        addData.idset = this.serviceFormData.nursingList.length + 1
        this.serviceFormData.nursingList.push(addData)
      } else {
        let index = this.serviceFormData.nursingList.findIndex(item => item.id === this.serviceTypeObj.id || item.id === this.serviceTypeObj.idset)
        // 替换
        this.serviceFormData.nursingList.splice(index, 1, addData)
      }
      this.$message.success('保存成功')
      // 移除校验
      this.$refs.serviceForm.clearValidate(['nursingList'])
      this.isShowAddService = false
      // 初始化添加服务
      this.initAddServiceForm()
    },
    // 接收添加的问卷
    receiveQuestion(data) {
      this.addQuestionObj = data
    },
    async getServiceTypeList() {
      let res = await serviceTypeList({})
      if (res.code === 0) {
        this.serviceTypeList = res.data
      }
    },
    // 删除类型
    handleDelType(row) {
      this.$confirm('请确认是否删除当前服务类型', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'message-confirm'
      }).then(async () => {
        let res = await deleteServiceType(row.id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getServiceTypeList()
        }
      })
    },
    // 获取详情
    async handleDetailContent(data) {
      // 初始化添加服务
      this.initAddServiceForm()
      this.isShowAddService = false
      // 初始化服务类型配置
      this.initServiceConfigForm()
      // this.selectId = data.id
      this.cloneMainRowData = DEEP_CLONE(data)
      this.serviceFormData = DEEP_CLONE(data)
    },
    // 保存
    async saveTypeForm() {
      let valRes
      this.$refs.serviceForm.validate(val => {
        valRes = val
      })
      // if (this.serviceFormData.nursingList.length === 0) {
      //   this.$message.warning('请添加服务')
      //   return
      // }
      if (!valRes) {
        return
      }
      if (!this.typeFlag) return
      this.typeFlag = false
      this.serviceFormData.nursingList.forEach(ele => {
        if (ele.idset) {
          delete ele.idset
        }
      })
      let res = await addServiceType({
        name: this.serviceFormData.name,
        id: this.serviceFormData.id,
        nursingList: this.serviceFormData.nursingList
      })
      if (res.code === 0) {
        this.$message.success('保存成功')
        this.isShowAddService = false
        this.typeFlag = true
        this.getServiceTypeList()
        // 初始化服务类型配置
        this.initServiceConfigForm()
      }
    },
    handleShowDialog() {
      this.showAddQuestion = true
    },
    handleCancel() {
      // 初始化添加服务
      this.initAddServiceForm()
      this.isShowAddService = false
      // 初始化服务类型配置
      this.initServiceConfigForm()
    },
    // 重置
    handleReset() {
      this.initAddServiceForm()
    },
    // 获取问卷详情，匹配问卷名称
    async getPageDetail(paperId) {
      let res = await questionnaireDetails({
        id: paperId
      })
      if (res.code === 0) {
        // this.questionnaireData = res.data
        this.addQuestionObj.title = res.data.title
        this.addQuestionObj.id = res.data.id
      }
    },
    // 查看
    async handleLook(row) {
      this.edit = false
      this.isCheck = false
      this.selectRow = row
      this.serviceTypeObj = DEEP_CLONE(row)
      this.serviceTypeObj.content = this.serviceTypeObj.risk
      this.serviceTypeObj.serviceTimeUnit = this.serviceTypeObj.serviceTimeUnit + ''
      let introductionList = JSON.parse(this.serviceTypeObj.introductionDetail)
      // this.serviceTypeObj.introductionList = []
      this.$set(this.serviceTypeObj, 'introductionList', [])
      introductionList.forEach(ele => {
        this.serviceTypeObj.introductionList.push({
          info: ele
        })
      })
      // this.editor.txt.html(this.serviceTypeObj.risk)
      await this.getPageDetail(this.serviceTypeObj.qsExamPaperId)
      this.isShowAddService = true
      // this.showAddQuestion = true
    },
    // 删除
    handleDel(index) {
      this.$confirm('确定要删除当前服务吗？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'message-confirm'
      }).then(async () => {
        this.serviceFormData.nursingList.splice(index, 1)
      })
    },
    contentChange(content) {
      this.serviceTypeObj.risk = content.content
      this.serviceTypeObj.content = content.content
    },
  }
}
</script>
<style lang="less" scoped>
.service-order-config-wrap {
  height: 100%;
  width: 100%;

  .item__error {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
  }

  .no-data {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }

  .el-button {
    font-family: 'Microsoft YaHei';
  }

  .active-bg {
    color: #1A7BFC;
  }

  .el-header {
    padding: 0 20px;
    text-align: left;
    background: #FFFFFF;
  }

  .tag {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    font-family: PingFangSC-Medium, PingFang SC;
    margin-bottom: 15px;
    display: flex;
    font-weight: 500;
  }

  .tag::before {
    content: '';
    display: block;
    width: 4px;
    height: 15px;
    background: #1A7BFC;
    margin-right: 15px;
    margin-top: 2.5px;
  }

  .el-aside {
    border-radius: 6px;
    background: #FFFFFF;
    height: calc(100% - 68px);
    width: 313px;
    margin-right: 16px;
    height: 100%;
    padding: 20px;

    .type-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // height: 46px;
      padding: 0 5px;
      border-radius: 8px;
      color: #333333;
    }

    .type-row:hover {
      background-color: #edf4ff;
    }
  }

  .content-form {
    background: #FFFFFF;
    // width: calc(100% - 1020px);
    // width: 40%;
    flex: 1;
    padding: 20px;
    overflow: hidden;
  }

  .add-item {
    // width: 100%;
    background-color: #FCFCFC;
    border: 1px dashed #D9D9D9;
    color: #333333;
    width: 247px;
    height: 35px;
  }

  .addservice:hover {
    // background-color: #1A7BFC;
    border: 1px dashed #1A7BFC;
    color: #1A7BFC;
  }

  .add-item-config {
    // width: 100%;
    background-color: #FCFCFC;
    border: 1px dashed #1A7BFC;
    // color: #1A7BFC;
    margin-bottom: 20px;
    width: 247px;
    height: 35px;
    // margin-left:180px;
  }

  .type-name {
    font-size: 14px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    // color: #333333;
    // line-height: 46px;
  }

  .type-option {
    display: flex;
    align-items: center;

    .el-button {
      font-size: 10px;
      font-weight: 400;
      color: #1A7BFC;
      // line-height: 46px;
    }
  }

  .footer-option {
    // text-align:center;
    padding-left: 130px;

    .el-button {
      width: 110px;
    }
  }

  /deep/.el-table__header th {
    padding: 0;
    height: 54px;
  }

  .btn-bg {
    background-color: #1A7BFC;
  }

  .el-button--text {
    color: #1A7BFC;
  }

  .line-sepa {
    display: inline-block;
    width: 1px;
    height: 14px;
    background-color: #1A7BFC;
    margin: 0 12px;
  }

  .add-service-form-content {
    background-color: #FFFFFF;
    padding: 20px;
    margin-left: 20px;
    overflow: auto;
    flex: 1.2;
  }

  .el-tag {
    border-radius: 18px;
  }

  /deep/.el-input-group__append {
    width: 90px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    font-family: 'Microsoft YaHei';
  }

  /deep/.el-input__inner {
    font-family: 'Microsoft YaHei' !important;
  }

  /deep/.el-textarea__inner {
    resize: none;
    font-family: 'Microsoft YaHei' !important;
  }

  .un-show-right {
    background-color: #FFFFFF;
    padding: 20px;
    overflow: auto;
    flex: 1.2;
  }

  // /deep/.el-form-item__content {
  //   min-width: 200px !important;
  // }
}
</style>
